import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { api, errMsg, fmtDateTime } from "@/lib/api";
import { useApp } from "@/context/AppContext";

const LABEL = { customer: "Customer", partner: "Pickup partner", support: "Kindsaver support" };

export const BookingChat = ({ messages = [], postUrl, me, onSent, testid = "booking-chat" }) => {
  const { t } = useApp();
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try { const { data } = await api.post(postUrl, { message: text }); setText(""); onSent(data); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2" data-testid={testid}>
      <div className="max-h-64 space-y-2 overflow-y-auto">
        {messages.map((m, i) => (
          <div key={`${m.at || ""}-${i}`} className={`max-w-[85%] rounded-2xl px-3 py-2 text-sm ${m.from === me ? "ml-auto bg-[#2E9E6B] text-white" : "bg-[#F4F8F5] text-[#0D3B2B]"}`} data-testid={`${testid}-msg-${i}`}>
            <p className={`text-[10px] font-bold uppercase ${m.from === me ? "text-white/80" : "text-[#2E9E6B]"}`}>{t(LABEL[m.from] || m.from)}{m.name ? ` · ${m.name}` : ""}</p>
            <p className="whitespace-pre-wrap">{m.text}</p>
            <p className={`text-[10px] ${m.from === me ? "text-white/70" : "text-[#7B968B]"}`}>{fmtDateTime(m.at)}</p>
          </div>
        ))}
        {!messages.length && <p className="text-sm text-[#7B968B]" data-testid={`${testid}-empty`}>{t("No messages yet.")}</p>}
      </div>
      <div className="flex gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder={t("Type a message…")}
          className="h-11 min-w-0 flex-1 rounded-xl border border-[#D2E0D8] bg-white px-3 text-base" data-testid={`${testid}-input`} />
        <button onClick={send} disabled={busy} className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#0D3B2B] text-white disabled:opacity-50" data-testid={`${testid}-send-btn`}><Send className="h-4 w-4" /></button>
      </div>
    </div>
  );
};
